<template>
  <v-dialog
    :model-value="open"
    :max-width="maxWidth"
    @update:model-value="onDialogUpdate"
  >
    <v-card class="org-settings-dialog elevation-8">
      <header class="org-settings-dialog__header">
        <div class="org-settings-dialog__header-icon">
          <v-icon :icon="icon || 'mdi-cog-outline'" size="20" />
        </div>
        <div class="org-settings-dialog__header-text">
          <h2 class="org-settings-dialog__header-title">{{ title }}</h2>
          <p v-if="subtitle" class="org-settings-dialog__header-subtitle">
            {{ subtitle }}
          </p>
        </div>
        <button
          type="button"
          class="org-settings-dialog__close"
          aria-label="Close"
          @click="$emit('close')"
        >
          <v-icon icon="mdi-close" size="18" />
        </button>
      </header>

      <div class="org-settings-dialog__body">
        <OrgSettingsDialogSection
          v-if="wrapInSectionCard"
          :title="sectionTitle"
          :icon="sectionIcon"
        >
          <slot />
        </OrgSettingsDialogSection>
        <slot v-else />
      </div>

      <footer v-if="$slots.footer" class="org-settings-dialog__footer">
        <slot name="footer" />
      </footer>
    </v-card>
  </v-dialog>
</template>

<script>
import OrgSettingsDialogSection from "@/components/MasterSettings/OrganizationSettings/OrgSettingsDialogSection.vue";

export default {
  name: "OrganizationSettingsDetailDialog",
  components: {
    OrgSettingsDialogSection,
  },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    sectionTitle: { type: String, default: "Settings details" },
    sectionIcon: { type: String, default: "mdi-cog-outline" },
    wrapInSectionCard: { type: Boolean, default: true },
    maxWidth: { type: [Number, String], default: 520 },
  },
  emits: ["close"],
  methods: {
    onDialogUpdate(value) {
      if (!value) {
        this.$emit("close");
      }
    },
  },
};
</script>
